// Procedural sound design with WebAudio: no audio assets needed.
// Wind = filtered noise, engine = detuned low oscillators, ambience = slow filtered noise.
let ctx = null;
let nodes = null;
let currentScene = 'airplane';
let enabled = false;

function noiseBuffer(c) {
  const len = c.sampleRate * 2;
  const buf = c.createBuffer(1, len, c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
  return buf;
}

function build() {
  ctx = new (window.AudioContext || window.webkitAudioContext)();
  const master = ctx.createGain();
  master.gain.value = 0;
  master.connect(ctx.destination);

  const mk = (type, freq, q = 1) => {
    const src = ctx.createBufferSource();
    src.buffer = noiseBuffer(ctx);
    src.loop = true;
    const f = ctx.createBiquadFilter();
    f.type = type; f.frequency.value = freq; f.Q.value = q;
    const g = ctx.createGain(); g.gain.value = 0;
    src.connect(f); f.connect(g); g.connect(master); src.start();
    return { src, f, g };
  };
  const wind = mk('bandpass', 600, 0.7);
  const ambience = mk('lowpass', 220, 0.5);

  const engG = ctx.createGain(); engG.gain.value = 0;
  const engF = ctx.createBiquadFilter(); engF.type = 'lowpass'; engF.frequency.value = 320;
  [52, 78, 104].forEach((fr) => {
    const o = ctx.createOscillator(); o.type = 'sawtooth'; o.frequency.value = fr; o.detune.value = Math.random() * 8;
    o.connect(engF); o.start();
  });
  engF.connect(engG); engG.connect(master);

  const lfo = ctx.createOscillator(); lfo.frequency.value = 0.15;
  const lfoG = ctx.createGain(); lfoG.gain.value = 250;
  lfo.connect(lfoG); lfoG.connect(wind.f.frequency); lfo.start();

  nodes = { master, wind, ambience, engG, engF };
}

const SCENES = {
  airplane: { wind: 0.12, windFreq: 500, engine: 0.11, ambience: 0.02 },
  jump: { wind: 0.3, windFreq: 700, engine: 0.2, ambience: 0.02 },
  freefall: { wind: 0.55, windFreq: 1100, engine: 0.03, ambience: 0.04 },
  clouds: { wind: 0.4, windFreq: 900, engine: 0, ambience: 0.08 },
  website: { wind: 0.07, windFreq: 420, engine: 0, ambience: 0.14 },
};

function apply(scene, t = 1.5) {
  if (!nodes) return;
  const s = SCENES[scene] || SCENES.website;
  const now = ctx.currentTime;
  const ramp = (p, v) => { p.cancelScheduledValues(now); p.setTargetAtTime(v, now, t / 3); };
  ramp(nodes.wind.g.gain, s.wind);
  ramp(nodes.wind.f.frequency, s.windFreq);
  ramp(nodes.engG.gain, s.engine);
  ramp(nodes.ambience.g.gain, s.ambience);
}

export const audio = {
  async setEnabled(on) {
    enabled = on;
    if (on && !ctx) build();
    if (!ctx) return;
    if (ctx.state === 'suspended') await ctx.resume();
    apply(currentScene, 0.6);
    nodes.master.gain.setTargetAtTime(on ? 0.8 : 0, ctx.currentTime, 0.25);
  },
  setScene(scene, t) {
    currentScene = scene;
    if (enabled) apply(scene, t);
  },
  isEnabled: () => enabled,
};
